import constants from './-constants'
import { OfferState } from './-types'

export default {
  [constants.getter.GET_OFFER](state: OfferState) {
    return state.offer
  }
}
